import api from '@/api/axios';

const categoriaModel = {

    async obtenerCategoriasLotes() {
        try {
            const response = await api.get('/categorias', {
                params: { with_count_lotes: true },
            });
            return response;
        } catch (error) {
            console.error("Error al obtener el lote:", error);
            throw error;
        }
    },

};

export default categoriaModel;